import Vue from 'vue'
import App from './App.vue'
//import config from '../config'
//import Webtrcview from './src/components/MonitorWebtrcView.html'

Vue.config.productionTip = false

//Vue.prototype.config = config

new Vue({
  render: h => h(App),
}).$mount('#app')
